// services/everpro/everpro-order/bulkLabel.ts - bulk.ts split (sub-module bulk label)

import { everproFetch } from '../everpro-auth';


export async function bulkGetEverproLabels(
  awbNumbers: string[],
  brandId: string,
): Promise<string[]> {
  if (!brandId) throw new Error('Everpro: brandId wajib');
  if (!awbNumbers.length) return [];

  const res = await everproFetch(brandId, '/shipment/v1/orders/label/bulk', {
    method: 'POST',
    body: JSON.stringify({ awb_numbers: awbNumbers }),
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    let message = '';
    try { message = JSON.parse(detail).message || ''; } catch { /* */ }
    throw new Error(message || `Everpro bulk label: ${res.status} ${res.statusText}`);
  }

  const json = await res.json();
  const items = json?.data ?? [];
  return (Array.isArray(items) ? items : [])
    .map((it: any) => it?.url_label_pdf || it?.label_url || '')
    .filter(Boolean);
}
